import axios from 'axios'
import authHeader from '@/services/AuthHeader'


export default() => {
	return axios.create({
		baseURL: process.env.VUE_APP_BASE_URL,
		headers: authHeader()
	})
}